// extracted by mini-css-extract-plugin
module.exports = {"spin":"HtcSpin_spin__1kkFQ"};